import React from "react";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex", 
    alignItems: "center", 
    gap: "20px", 
    border: "1px solid #6A6A6A",
    padding: "10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  filterIcon: {
    width: "20px",
    height: "20px",
    transition: "fill 0.3s ease",
  },
}));

const StockItem = ({ stock, selected, setSelected }) => {
  const backgroundColor = (selected && selected.name === stock.name) ? "#1d4d9d" : "#fff";
  const textColor = (selected && selected.name === stock.name) ? "#fff" : "#000";

  const classes = useStyles();

  return (
    <div 
      className={classes.item}
      style={{
        backgroundColor: backgroundColor,
      }}
      onClick={() => {
        if (selected && selected.name === stock.name) {
          setSelected(null);
          return;
        }
        setSelected(stock);
      }}
    >
      <div
        className="circle-ingreso"
        style={{
          minWidth: "20px",
          minHeight: "20px",
          backgroundColor: stock.color,
          border: stock.name === "Plásticos" ? "1px solid #6A6A6A" : "none"
        }}
      ></div>
      <div 
        className="mb-0 text-residuo"
        style={{
          minWidth: "140px",
          color: textColor,
        }}
      >
        {stock.name}
      </div>
      <div 
        className="mb-0"
        style={{
          minWidth: "80px",
          color: textColor,
        }}
      >
        {(parseFloat(stock.stock) / 1000).toFixed(2)} T
      </div>
      <svg 
        viewBox="0 0 24 24" 
        className={classes.filterIcon}
        style={{
          color: textColor,
        }}
      >
        <path 
          d="M3 4h18v2.172l-7 7V20l-4-2v-4.828l-7-7V4z" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default StockItem;
